import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { BaseComponent } from "./components/base/base.component";
import { HomeComponent } from "./components/home/home.component";
import { SearchComponent } from "./components/dmv/search/search.component";
import { SearchResultsComponent } from "./components/dmv/search-results/search-results.component";
import { CountyLandingComponent } from "./components/dmv/county-landing/county-landing.component";
import { CustomizeOrderComponent } from "./components/dmv/customize-order/customize-order.component";
import { DmvDonationComponent } from "./components/dmv/donation/donation.component";
import { DmvPickupMethodComponent } from "./components/dmv/pickup-method/pickup-method.component";
import { DmvPickupMailingComponent } from "./components/dmv/pickup-mailing/pickup-mailing.component";
import { DmvPickupInPersonComponent } from "./components/dmv/pickup-in-person/pickup-in-person.component";
import { DmvReviewCartComponent } from "./components/dmv/review-cart/review-cart.component";
import { DmvReviewCartWithBillingComponent } from "./components/dmv/dmv-review-cart/dmv-review-cart.component";
import { ManualRenewComponent } from "./components/dmv/manual-renew/manual-renew.component";
import { PaymentDetailsComponent } from "./components/payment/payment-details/payment-details.component";
import { AboutComponent } from "./components/about/about.component";
import { PNPPaymentDetailsComponent } from "./components/pnp-payment/payment-details/payment-details.component";
import { CreateAccountComponent } from "./components/user/create-account/create-account.component";
import { LogInComponent } from "./components/user/log-in/log-in.component";
import { AccountFaqComponent } from "./components/user/account-faq/account-faq.component";
import { ProfileComponent } from "./components/user/profile/profile.component";
import { AccountCreatedComponent } from "./components/user/account-created/account-created.component";
import { EditContactInfoComponent } from "./components/user/edit-contact-info/edit-contact-info.component";
import { EditPaymentMethodComponent } from "./components/user/edit-payment-method/edit-payment-method.component";
import { ChangeEmailAddressComponent } from "./components/user/change-email-address/change-email-address.component";
import { ChangePasswordComponent } from "./components/user/change-password/change-password.component";
import { ContactInfoComponent } from "./components/user/contact-info/contact-info.component";
import { NotificationsComponent } from "./components/user/notifications/notifications.component";
import { PaymentMethodsComponent } from "./components/user/payment-methods/payment-methods.component";
import { ResetPasswordComponent } from "./components/user/reset-password/reset-password.component";
import { SelectPaymentMethodComponent } from "./components/user/select-payment-method/select-payment-method.component";
import { BillingAccountComponent } from "./components/user/billing-account/billing-account.component";
import { ResetPasswordSucessComponent } from "./components/user/reset-password-sucess/reset-password-sucess.component";
import { PasswordChangedComponent } from "./components/user/password-changed/password-changed.component";
import { EmailAddressChangedComponent } from "./components/user/email-address-changed/email-address-changed.component";
import { GsgPaymentDetailsComponent } from "./components/gsg-payment/payment-details/payment-details.component";
import { MegPaymentDetailComponent } from "./components/meg-payment/payment-detail/payment-detail.component";
import { DuplicateComponent } from "./components/dmv/dublicate/duplicate.component";
import { EnrollmentCancellationComponent } from "./components/user/enrollment-cancellation/enrollment-cancellation.component";
import { EnrollmentComponent } from "./components/user/enrollment/enrollment.component";
import { AnnouncementComponent } from "./components/announcement/announcement.component";
const routes: Routes = [
	{ path: "base", component: BaseComponent },
	{ path: "home", component: HomeComponent },
	{ path: "county-landing", component: CountyLandingComponent },
	{ path: "dmv-search", component: SearchComponent },
	{ path: "dmv-search-results", component: SearchResultsComponent },
	{ path: "dmv-customize-order", component: CustomizeOrderComponent },
	{ path: "dmv-donation", component: DmvDonationComponent },
	{ path: "dmv-pickup-method", component: DmvPickupMethodComponent },
	{ path: "dmv-pickup-mailing", component: DmvPickupMailingComponent },
	{ path: "dmv-pickup-in-person", component: DmvPickupInPersonComponent },
	{ path: "dmv-review-cart", component: DmvReviewCartComponent },
	{ path: "payment", component: PaymentDetailsComponent },
	{ path: "about", component: AboutComponent },
	{ path: "pnp-payment", component: PNPPaymentDetailsComponent },
	{ path: "gsg-payment", component: GsgPaymentDetailsComponent },
	{ path: "pnp-payment", component: PNPPaymentDetailsComponent },
	{ path: "meg-payment", component: MegPaymentDetailComponent },
	{
		path: "dmv-review-cart-with-billing",
		component: DmvReviewCartWithBillingComponent
	},
	{
		path: "dmv-manual-renew",
		component: ManualRenewComponent
	},
	{
		path: "log-in",
		component: LogInComponent
	},
	{
		path: "create-account",
		component: CreateAccountComponent
	},
	{
		path: "account-faqs",
		component: AccountFaqComponent
	},
	{
		path: "profile",
		component: ProfileComponent
	},
	{
		path: "account-created",
		component: AccountCreatedComponent
	},
	{
		path: "edit-contact-info",
		component: EditContactInfoComponent
	},
	{
		path: "edit-payment-method",
		component: EditPaymentMethodComponent
	},
	{
		path: "change-email-address",
		component: ChangeEmailAddressComponent
	},
	{
		path: "change-password",
		component: ChangePasswordComponent
	},
	{
		path: "contact-info",
		component: ContactInfoComponent
	},
	{
		path: "notifications",
		component: NotificationsComponent
	},
	{
		path: "payment-methods",
		component: PaymentMethodsComponent
	},
	{
		path: "reset-password",
		component: ResetPasswordComponent
	},
	{
		path: "select-payment-method",
		component: SelectPaymentMethodComponent
	},
	{
		path: "billing-account",
		component: BillingAccountComponent
	},
	{
		path: "reset-password-sucess",
		component: ResetPasswordSucessComponent
	},
	{
		path: "password-changed",
		component: PasswordChangedComponent
	},
	{
		path: "email-address-changed",
		component: EmailAddressChangedComponent
	},
	{
		path: "dmv-duplicate",
		component: DuplicateComponent
	},
	{
		path: "app-enrollment-cancellation",
		component: EnrollmentCancellationComponent
	},
	{
		path: "app-enrollment",
		component: EnrollmentComponent
	},
	{
		path: "app-announcement",
		component: AnnouncementComponent
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule {}
